import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import Check from "@material-ui/icons/Check";
import Remove from "@material-ui/icons/Remove";
import Info from "@material-ui/icons/Info";
import IconButton from '@material-ui/core/IconButton';

import TComboBox from "../../common/TComboBox";
import TRadioGroup from "../../common/TRadioGroup";
import TDialog from "../../common/TDialog";

import GBStdTable from "../../common/GBStdTableAG/GbStdTable";

import * as Theme from "../../../app/Theme";

import {
    getGenderPlural,
    cloneObj,
} from "../../GB/GBUtil";
import * as gbc from "../../GB/GBConst";
import * as gbtu from "../../GB/GBTableUtil";
import * as gbtc from "../../GB/GBTableConst";

import * as rcc from "../NonVisual/RCConst";
import * as rcdu from "../NonVisual/RCDataUtil";
import * as rcu from "../NonVisual/RCUtil";
import RCNavBtnDiv from "../Other/RCNavBtnDiv";

/* Having a hidden column lets us edit text in the first visible column. */
const hiddenCol     = 0;
const paramNameCol  = 1;
const valueCol      = 2;
const numCols       = valueCol + 1;

const colHeadingRow = 0;
const numRows       = rcc.numHHConvFactorParams + 1;

const HHResponseRateRDec = 3;

const paramComboWidth = 175;

const paramComboBoxMarginTop = 5;

const comboCaptionSize = 20;

class RCAssignTargPopsForm extends Component {

    static propTypes = {

        onPageChange                : PropTypes.func,

        onQ1Answered                : PropTypes.func,

        targPopObjList              : PropTypes.arrayOf(PropTypes.object),

        indicatorObjList            : PropTypes.arrayOf(PropTypes.object),
        onIndicatorParamLabChange   : PropTypes.func,
        onIndicatorTargPopCurrIDChange : PropTypes.func,
        onIndicatorTargPopTypeChange : PropTypes.func,
        onIndicatorObjListChange    : PropTypes.func,

        selectedIndCurrID           : PropTypes.number,
        onSelectedIndicatorChange   : PropTypes.func,

        onTargPopParamValueChange   : PropTypes.func,
        onTargPopCustomStrChange    : PropTypes.func,

    };

    static defaultProps = {

        onPageChange                : () => console.log("onPageChange"),

        onQ1Answered                : () => console.log("onQ1Answered"),

        targPopObjList              : [],

        indicatorObjList            : [],
        onIndicatorParamLabChange   : () => console.log("onIndicatorParamLabChange"),
        onIndicatorTargPopCurrIDChange : () => console.log("onIndicatorTargPopCurrIDChange"),
        onIndicatorTargPopTypeChange : () => console.log("onIndicatorTargPopTypeChange"),
        onIndicatorObjListChange    : () => console.log("onIndicatorObjListChange"),

        selectedIndCurrID           : 1,
        onSelectedIndicatorChange   : () => console.log("onSelectedIndicatorChange"),

        onTargPopParamValueChange   : () => console.log("onTargPopParamValueChange"),
        onTargPopCustomStrChange    : () => console.log("onTargPopCustomStrChange"),
    };

    state = {

        showParamsHelpDialog : false,

    };

    onParamsInfoClick = () => {

        this.setState({

            showParamsHelpDialog : true,

        });

    };

    onParamsDialogClose = () => {

        this.setState({

            showParamsHelpDialog : false,

        });

    };

    onStartAgeComboBoxChange = (value, text, info) => {

        try {

            /* props */
            const props = this.props;
            const selectedIndCurrID = props.selectedIndCurrID;

            if (info !== RS(SC.GB_stSelect)) {

                this.props.onIndicatorParamLabChange(selectedIndCurrID, rcc.startAgeLab, info);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onEndAgeComboBoxChange = (value, text, info) => {

        try {

            /* props */
            const props = this.props;
            const selectedIndCurrID = props.selectedIndCurrID;

            if (info !== RS(SC.GB_stSelect)) {

                this.props.onIndicatorParamLabChange(selectedIndCurrID, rcc.endAgeLab, info);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onRefPeriodComboBoxChange = (value, text, info) => {

        try {

            /* props */
            const props = this.props;
            const selectedIndCurrID = props.selectedIndCurrID;

            if (info !== RS(SC.GB_stSelect)) {

                this.props.onIndicatorParamLabChange(selectedIndCurrID, rcc.refPeriodLab, info);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onGenderComboBoxChange = (value, text, info) => {

        try {

            /* props */
            const props = this.props;
            const selectedIndCurrID = props.selectedIndCurrID;

            if (info !== RS(SC.GB_stSelect)) {

                this.props.onIndicatorParamLabChange(selectedIndCurrID, rcc.genderLab, info);

            }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onIndComboBoxChange = (value, text, info) => {

        try {

            const props = this.props;
            const indicatorObjList = cloneObj(props.indicatorObjList);

            const selectedIndCurrID = rcdu.getIndCurrID(info, indicatorObjList);

            props.onSelectedIndicatorChange(selectedIndCurrID, () => {

                rcdu.onIndicatorTargPopCurrIDChange(selectedIndCurrID, indicatorObjList);

                props.onIndicatorObjListChange(indicatorObjList);

            });

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onTargPopComboBoxChange = (value, text, info) => {

        try {

            const props = this.props;
            const selectedIndCurrID = props.selectedIndCurrID;

            this.props.onIndicatorTargPopCurrIDChange(selectedIndCurrID, info);

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onCustomIndTargPopTypeRadGrpChange = (value) => {

        try {

            const props = this.props;
            const selectedIndCurrID = props.selectedIndCurrID;

            props.onIndicatorTargPopTypeChange(selectedIndCurrID, value + 1);

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    // Math.round(parseFloat(value)*100000) < Math.round(parseFloat(max)*100000)

    onTargPopParamsPackTableChange = (newPackTable) => {

        try {

            const props = this.props;
            const selectedIndCurrID = props.selectedIndCurrID;
            const indicatorObjList = props.indicatorObjList;

            const values2DArray = gbtu.getPackTableValues(newPackTable);
            const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
            const targPopType = rcdu.getIndTargPopType(selectedIndCurrID, indicatorObjList);

            const tolerance = 1;

            let stop = false;
            let r = 1;
            while ((r <= rcc.numHHConvFactorParams) && (!stop)) {

                const oldValue = rcdu.getIndParamValue(r, selectedIndCurrID, indicatorObjList);

                const newValue = values2DArray[r][valueCol];

                const oldValueAsStr = oldValue.toFixed(3);
                const newValueAsStr = newValue.toFixed(3);

                const oldValueInt = parseFloat(oldValueAsStr) * 1000;
                const newValueInt = parseFloat(newValueAsStr) * 1000;

                if (Math.abs(oldValueInt - newValueInt) > tolerance) {

                    this.props.onTargPopParamValueChange(selectedIndCurrID, r, newValue);
                    stop = true;

                }

                if (customIndBool && (targPopType === rcc.customTargPop) && (r === rcc.targPopParam)) {

                    const oldTargPopCustomStr = rcdu.getIndTargPopCustomStr(selectedIndCurrID, indicatorObjList);
                    const newTargPopCustomStr = values2DArray[r][paramNameCol];

                    if (oldTargPopCustomStr !== newTargPopCustomStr) {

                        this.props.onTargPopCustomStrChange(selectedIndCurrID, newTargPopCustomStr);
                        stop = true;

                    }

                }

                r++;
            }


        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    onNextBtnClick = () => {

        try {

            this.props.onPageChange(rcc.parametersForm);

            /* For this to truly work nice, the onPageChange should check and see if all indicators
               have been completed. If they haven't, only proceed if the user says "yes, I want to proceed without filling them all in anyway."*/
            // if (!allIndCompleted(this.props.indicatorObjList)) {
            //
            //     alert("Please fill out the information for every indicator you select in the previous step.");
            //
            // }
            // else {
            //
            //     this.props.onPageChange(RCConst.parametersForm);
            //
            // }

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);

        }

    };

    renderTargPopParamsTable = () => {

        try {

            let targPopParamsTable;

            const props = this.props;
            const targPopObjList = props.targPopObjList;
            const selectedIndCurrID = props.selectedIndCurrID;
            const indicatorObjList = props.indicatorObjList;

            const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
            const targPopType = rcdu.getIndTargPopType(selectedIndCurrID, indicatorObjList);

            let packTable = gbtu.getNewPackTable();
            packTable = gbtu.resizePackTable(packTable, numRows, numCols);

            packTable = gbtu.setColWidth(packTable, hiddenCol, 0);
            packTable = gbtu.setColWidth(packTable, paramNameCol, 400);
            packTable = gbtu.setColWidth(packTable, valueCol, 100);

            packTable = gbtu.setWordWrappedCol(packTable, paramNameCol, true);

            packTable = gbtu.setValue(packTable, colHeadingRow, paramNameCol, RS(SC.GB_stParameter));
            packTable = gbtu.setValue(packTable, colHeadingRow, valueCol, RS(SC.GB_stValue));

            for (let r = 1; r < numRows; r++) {

                let paramName;

                /* Replace XX, YY, ZZ, etc. placeholders */
                if (!(customIndBool && (targPopType === rcc.customTargPop) && (r === rcc.targPopParam))) {

                    paramName = rcdu.replaceTargPopParams(
                        r, selectedIndCurrID, indicatorObjList, targPopObjList);

                    packTable = gbtu.lockCell(packTable, r, paramNameCol, true, false);

                }
                else {

                    paramName = rcdu.getIndTargPopCustomStr(selectedIndCurrID, indicatorObjList);
                    packTable = gbtu.setMinAllowedVal(packTable, r, paramNameCol, 0);
                    packTable = gbtu.setMaxAllowedVal(packTable, r, paramNameCol, 0);

                }

                const paramValue = rcdu.getIndParamValue(r, selectedIndCurrID, indicatorObjList);

                packTable = gbtu.setValue(packTable, r, paramNameCol, paramName);
                packTable = gbtu.setValue(packTable, r, valueCol, paramValue);
                packTable = gbtu.setMaxAllowedVal(packTable, r, valueCol, 9999999999);

            }

            packTable = gbtu.setMaxAllowedVal(packTable, rcc.HHResponseRateParam, valueCol, 1);
            packTable = gbtu.setRDec(packTable, rcc.HHResponseRateParam, valueCol, HHResponseRateRDec);
            packTable = gbtu.alignNumericCellsRight(packTable);
            packTable = gbtu.setRowAlignment(packTable, colHeadingRow, gbtc.hAlign.center);
            // Sometimes slow and cannot do this without losing the focus on the selected cell. This makes
            // navigation a pain, detracting from the user experience.
            // for (let r = 0; r < numRows; r++) {
            //
            //     for (let c = 0; c < numCols; c++) {
            //
            //         const value = gbtu.getValue(packTable, r, c);
            //
            //         if (typeof value === "number") {
            //
            //             let numDecPlaces = gbu.decimalPlaces(value);
            //
            //             if ((r === rcc.HHResponseRateParam) && (c === valueCol)) {
            //
            //                 numDecPlaces = Math.max(numDecPlaces, HHResponseRateDecPlaces);
            //
            //             }
            //
            //             packTable = gbtu.setRDec(packTable, r, c, numDecPlaces);
            //
            //         }
            //
            //     }
            //
            // }

            targPopParamsTable =
                <GBStdTable
                    headerBackgroundColor = {Theme.RC_PalatinatePurple}
                    oddRowBackgroundColor = {Theme.RC_BandColor}
                    packTable             = {packTable}
                    onPackTableChanged    = {this.onTargPopParamsPackTableChange}
                    removedMenuNames      = {gbtc.menuItems.filter((s) => {

                        const menuItemsToRemove = gbtc.sector4_MIs.concat(
                            gbtc.sector5_MIs, gbtc.sector6_MIs
                        );

                        return menuItemsToRemove.includes(s);

                    })}
                    style                 = {{
                        marginLeft : Theme.leftIndent,
                        marginTop  : Theme.topIndent,
                    }}
                />;

            return targPopParamsTable;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderIndComboBox = () => {

        try {

            let indComboBox;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const selectedIndCurrID = props.selectedIndCurrID;

            const totalNumInd = rcdu.getTotalNumInd(indicatorObjList);

            let indNames1DStrArray = [];
            let indMstIDs1DIntArray = [];
            let contentRightArray = [];

            let idx = 0;
            let indComboBoxIdx = 0;
            for (let i = 1; i <= totalNumInd; i++) {

                const indMstID = rcdu.getIndMstID(i, indicatorObjList);

                if (rcdu.getIndAnalyzeBool(i, indicatorObjList)) {

                    indNames1DStrArray.push(rcdu.getIndName(i, indicatorObjList));
                    indMstIDs1DIntArray.push(indMstID);

                    /* Determine the status of the indicator */
                    const status = rcdu.getIndStatus(i, indicatorObjList);

                    let statusIcon;

                    if (status === rcc.indCompleted) {

                        statusIcon =
                            <Check
                                style = {{
                                    color       : Theme.RC_ElfGreenColor,
                                    marginLeft : 10,
                                }}
                            />;

                    }
                    else {

                        statusIcon =
                            <Remove
                                style = {{
                                    color      : Theme.RC_RustColor,
                                    marginLeft : 10,
                                }}
                            />;

                    }

                    contentRightArray.push(statusIcon);

                    //if (getDefIndCurrID(indMstID) === selectedIndCurrID) {
                    if (i === selectedIndCurrID) {

                        indComboBoxIdx = idx;

                    }

                    idx++;

                }

            }

            indComboBox =
                <TComboBox
                    contentRight = {contentRightArray}
                    onChange     = {this.onIndComboBoxChange}
                    info         = {indMstIDs1DIntArray}
                    itemIndex    = {indComboBoxIdx}
                    items        = {indNames1DStrArray}
                    key          = {"indComboBox"}
                    outerStyle   = {{
                        marginLeft : Theme.leftIndent,

                    }}
                    style = {{
                        width      : 600,
                        display    : "inline-block",
                    }}
                />;

            return indComboBox;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderTargPopLabAndComboBox = () => {

        try {

            let targPopComboBox = null;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const selectedIndCurrID = props.selectedIndCurrID;

            const targPopCurrID = rcdu.getIndTargPopCurrID(selectedIndCurrID, indicatorObjList);
            const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
            let targPopType = rcc.defaultTargPop;
            if (customIndBool) {

                targPopType = rcdu.getIndTargPopType(selectedIndCurrID, indicatorObjList);

            }

            let selectTargPopInstructLab = null;

            if (customIndBool && (targPopType !== rcc.customTargPop)) {

                selectTargPopInstructLab =
                    <p
                        color   = {Theme.RC_HippieBlue}
                        key     = {"selectTargPopInstructLab"}
                        style   = {{
                            ...Theme.labelStyle,
                            marginBottom : 0,
                            marginLeft   : Theme.leftIndent,
                            marginTop    : 20,
                        }}
                    >
                        {RS(SC.GB_stSelectTargPop)}
                    </p>;

                let targPopNames1DStrArray = [];
                let targPopCurrIDs1DIntArray = [];
                let targPopComboBoxIdx = 0;

                const indPossibleTargPop1DIntArray =
                    rcdu.getIndPossibleTargPop1DIntArray(selectedIndCurrID, indicatorObjList);

                for (let i = 1; i <= indPossibleTargPop1DIntArray.length; i++) {

                    const targPopCurrIDL = indPossibleTargPop1DIntArray[i - 1];
                    targPopNames1DStrArray.push(rcu.getDefTargPopName(targPopCurrIDL));
                    targPopCurrIDs1DIntArray.push(targPopCurrIDL);

                    if (targPopCurrIDL === targPopCurrID) {

                        targPopComboBoxIdx = i - 1;

                    }

                }

                targPopComboBox =
                    <TComboBox
                        onChange   = {this.onTargPopComboBoxChange}
                        info       = {targPopCurrIDs1DIntArray}
                        itemIndex  = {targPopComboBoxIdx}
                        items      = {targPopNames1DStrArray}
                        key        = {"targPopComboBox"}
                        style = {{
                            marginLeft : Theme.leftIndent,
                            width      : 500,
                        }}
                    />;

            }

            return (

                <React.Fragment>

                    {selectTargPopInstructLab}
                    {targPopComboBox}

                </React.Fragment>

            );

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderStartAgeComboBox = () => {

        try {

            let startAgeComboBox = null;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const selectedIndCurrID = props.selectedIndCurrID;

            const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
            const targPopCurrID = rcdu.getIndTargPopCurrID(selectedIndCurrID, indicatorObjList);

            let indCurrID = selectedIndCurrID;
            if (customIndBool) {

                indCurrID = rcu.getDefIndCurrIDFromTargPopCurrID(targPopCurrID);

            }

            const defIndAgeLowerBoundStart = rcu.getDefIndAgeLowerBoundStart(indCurrID);
            const defIndAgeLowerBoundEnd = rcu.getDefIndAgeLowerBoundEnd(indCurrID);

            if ((defIndAgeLowerBoundStart !== RS(SC.GB_stNA)) &&
                (defIndAgeLowerBoundEnd !== RS(SC.GB_stNA))) {

                let startAge = rcdu.getIndTargPopLabStartAge(selectedIndCurrID, indicatorObjList);

                let itemIdx = 0; // "Select"
                if (startAge !== RS(SC.GB_stNA)) {

                    itemIdx = startAge - defIndAgeLowerBoundStart + 1; // +1 because of Select at index 0

                }

                let ageIndices1DIntArray = [RS(SC.GB_stSelect)];

                for (let a = defIndAgeLowerBoundStart; a <= defIndAgeLowerBoundEnd; a++) {

                    ageIndices1DIntArray.push(a);

                }

                startAgeComboBox =
                    <TComboBox
                        caption      = {RS(SC.GB_stStartAgeXX)}
                        captionStyle = {{
                            fontSize : comboCaptionSize,
                        }}
                        onChange     = {this.onStartAgeComboBoxChange}
                        info         = {ageIndices1DIntArray}
                        itemIndex    = {itemIdx}
                        items        = {ageIndices1DIntArray}
                        key          = {"startAgeComboBox"}
                        outerStyle   = {{
                            marginLeft : Theme.leftIndent,
                            marginTop  : paramComboBoxMarginTop,
                        }}
                        width      = {paramComboWidth}
                    />;

            }

            return startAgeComboBox;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderEndAgeComboBox = () => {

        try {

            let endAgeComboBox = null;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const selectedIndCurrID = props.selectedIndCurrID;

            const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
            const targPopCurrID = rcdu.getIndTargPopCurrID(selectedIndCurrID, indicatorObjList);

            let indCurrID = selectedIndCurrID;
            if (customIndBool) {

                indCurrID = rcu.getDefIndCurrIDFromTargPopCurrID(targPopCurrID);

            }

            const defIndAgeUpperBoundStart = rcu.getDefIndAgeUpperBoundStart(indCurrID);
            const defIndAgeUpperBoundEnd = rcu.getDefIndAgeUpperBoundEnd(indCurrID);

            if ((defIndAgeUpperBoundStart !== RS(SC.GB_stNA)) &&
                (defIndAgeUpperBoundEnd !== RS(SC.GB_stNA))) {

                let endAge = rcdu.getIndTargPopLabEndAge(selectedIndCurrID, indicatorObjList);
                let startAge = rcdu.getIndTargPopLabStartAge(selectedIndCurrID, indicatorObjList);

                let a1;
                if (startAge !== RS(SC.GB_stNA)) {

                    a1 = startAge;

                }
                else {

                    a1 = defIndAgeUpperBoundStart;

                }


                let itemIdx = 0; // "Select"
                if (endAge !== RS(SC.GB_stNA)) {

                    itemIdx = endAge - a1 + 1; // +1 because of Select at index 0

                }

                let ageIndices1DIntArray = [RS(SC.GB_stSelect)];


                for (let a = a1; a <= defIndAgeUpperBoundEnd; a++) {

                    ageIndices1DIntArray.push(a);

                }

                endAgeComboBox =
                    <TComboBox
                        caption      = {RS(SC.GB_stEndAgeYY)}
                        captionStyle = {{
                            fontSize : comboCaptionSize,
                        }}
                        onChange     = {this.onEndAgeComboBoxChange}
                        info         = {ageIndices1DIntArray}
                        itemIndex    = {itemIdx}
                        items        = {ageIndices1DIntArray}
                        key          = {"endAgeComboBox"}
                        outerStyle   = {{
                            marginLeft : Theme.leftIndent,
                            marginTop  : paramComboBoxMarginTop,
                        }}
                        width        = {paramComboWidth}
                    />;

            }

            return endAgeComboBox;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderRefPeriodComboBox = () => {

        try {

            let refPeriodComboBox = null;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const selectedIndCurrID = props.selectedIndCurrID;

            const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
            const targPopCurrID = rcdu.getIndTargPopCurrID(selectedIndCurrID, indicatorObjList);

            let indCurrID = selectedIndCurrID;
            if (customIndBool) {

                indCurrID = rcu.getDefIndCurrIDFromTargPopCurrID(targPopCurrID);

            }

            const defIndRefPeriod = rcu.getDefIndRefPeriod(indCurrID);

            if (defIndRefPeriod !== RS(SC.GB_stNA)) {

                let refPeriod = rcdu.getIndTargPopLabRefPeriod(selectedIndCurrID, indicatorObjList);

                let itemIdx = 0; // "Select"
                if (refPeriod !== RS(SC.GB_stNA)) {

                    itemIdx =  defIndRefPeriod.indexOf(refPeriod) + 1; // +1 because of Select at index 0

                }

                let refPeriod1DArray = cloneObj(defIndRefPeriod);
                refPeriod1DArray.unshift(RS(SC.GB_stSelect));

                refPeriodComboBox =
                    <TComboBox
                        caption      = {RS(SC.GB_stRefPeriodZZ)}
                        captionStyle = {{
                            fontSize : comboCaptionSize,
                        }}
                        onChange     = {this.onRefPeriodComboBoxChange}
                        info         = {refPeriod1DArray}
                        itemIndex    = {itemIdx}
                        items        = {refPeriod1DArray}
                        key          = {"refPeriodComboBox"}
                        outerStyle   = {{
                            marginLeft : Theme.leftIndent,
                            marginTop  : paramComboBoxMarginTop,
                        }}
                        width        = {paramComboWidth}
                    />;

            }

            return refPeriodComboBox;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    renderGenderComboBox = () => {

        try {

            let genderComboBox = null;

            const props = this.props;
            const indicatorObjList = props.indicatorObjList;
            const selectedIndCurrID = props.selectedIndCurrID;

            const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
            const targPopCurrID = rcdu.getIndTargPopCurrID(selectedIndCurrID, indicatorObjList);

            let indCurrID = selectedIndCurrID;
            if (customIndBool) {

                indCurrID = rcu.getDefIndCurrIDFromTargPopCurrID(targPopCurrID);

            }

            const defIndGender = rcu.getDefIndGender(indCurrID);

            if (defIndGender !== RS(SC.GB_stNA)) {

                const gender1DIntArray = [
                    RS(SC.GB_stSelect),
                    gbc.sex.both,
                    gbc.sex.female,
                    gbc.sex.male,
                ];

                let gender1DStrArray = rcu.getGenderArray();
                gender1DStrArray.unshift(RS(SC.GB_stSelect));

                let gender = rcdu.getIndTargPopLabGender(selectedIndCurrID, indicatorObjList);

                let itemIdx = 0; // "Select"
                if (gender !== RS(SC.GB_stNA)) {

                    itemIdx = defIndGender.indexOf(getGenderPlural(gender, false)) + 1; // +1 because of Select at index 0

                }

                genderComboBox =
                    <TComboBox
                        caption      = {RS(SC.GB_stGender)}
                        captionStyle = {{
                            fontSize : comboCaptionSize,
                        }}
                        onChange     = {this.onGenderComboBoxChange}
                        info         = {gender1DIntArray}
                        itemIndex    = {itemIdx}
                        items        = {gender1DStrArray}
                        key          = {"genderComboBox"}
                        outerStyle   = {{
                            marginLeft : Theme.leftIndent,
                            marginTop  : paramComboBoxMarginTop,
                        }}
                        width        = {paramComboWidth}
                    />;

            }

            return genderComboBox;

        }
        catch (exception) {

            alert(exception.name + ': ' + exception.message);
            return null;

        }

    };

    render() {

        /* props */

        const props = this.props;
        const indicatorObjList = props.indicatorObjList;
        const selectedIndCurrID = props.selectedIndCurrID;
        const onPageChange = props.onPageChange;

        /* state */

        const state = this.state;
        const showParamsHelpDialog = state.showParamsHelpDialog;

        const customIndBool = rcdu.getIndCustomBool(selectedIndCurrID, indicatorObjList);
        const targPopCurrID = rcdu.getIndTargPopCurrID(selectedIndCurrID, indicatorObjList);

        let targPopType = rcc.defaultTargPop;
        if (customIndBool) {

            targPopType = rcdu.getIndTargPopType(selectedIndCurrID, indicatorObjList);

        }

        const selectIndInstructLab =
            <p
                key     = {"selectIndInstructLab"}
                style   = {{
                    ...Theme.labelStyle,
                    color        : Theme.RC_HippieBlue,
                    marginBottom : 0,
                    marginLeft   : Theme.leftIndent,
                    marginRight  : 20,
                    marginTop    : Theme.topIndentFirstCtrl,
                }}
            >
                {RS(SC.GB_stIndInstructions)}
            </p>;

        const fillOutAllIndNote =
            <p
                key     = {"selectIndInstructLab"}
                style   = {{
                    ...Theme.labelStyle,
                    color        : Theme.RC_RustColor,
                    marginBottom : 15,
                    marginLeft   : Theme.leftIndent,
                    marginRight  : 20,
                    marginTop    : Theme.topIndentFirstCtrl,
                }}
            >
                {RS(SC.GB_stAllIndFillOut)}
            </p>;

        const indComboBox = this.renderIndComboBox();

        const indCompleted = rcdu.getNumIndCompleted(indicatorObjList);
        const indAnalyzed = rcdu.getNumIndAnalyzed(indicatorObjList);

        let indCompletedLabColor = Theme.blackColor;

        if (indCompleted === indAnalyzed) {

            indCompletedLabColor = Theme.RC_ElfGreenColor;

        }

        const indCompletedLab =
            <p
                style = {{
                    color        : indCompletedLabColor,
                    marginBottom : 0,
                    marginLeft   : Theme.leftIndent,
                    marginTop    : 0,
                }}
            >
                {RS(SC.GB_stIndCompleted)}: {indCompleted} / {indAnalyzed}
            </p>;

        const indDiv =
            <div
                key   = {"indDiv"}
                style = {{
                    alignItems : "center",
                    display    : "flex",
                    flexWrap   : "wrap",
                }}
            >
                {indComboBox}
                {indCompletedLab}
            </div>;

        let customIndTargPopTypeRadGrp = null;
        if (customIndBool) {

            customIndTargPopTypeRadGrp =
                <TRadioGroup
                    caption      = {RS(SC.GB_stHowSpecTargPop)}
                    captionStyle = {{
                        ...Theme.labelStyle,
                        color        : Theme.RC_HippieBlue,
                        marginBottom : 10,
                        marginTop    : 0,
                    }}
                    handleChange = {this.onCustomIndTargPopTypeRadGrpChange}
                    itemIndex    = {targPopType - 1}
                    items        = {[
                        RS(SC.GB_stChooseDefTargPop),
                        RS(SC.GB_stEnterCustomTargPop),
                    ]}
                    itemStyle    = {{
                        marginLeft : Theme.leftIndent,
                    }}
                    row          = {false}
                    style        = {{
                        marginLeft   : Theme.leftIndent,
                        marginBottom : 0,
                        marginTop    : 20,
                        padding      : 0,
                    }}
                />;

        }

        const targPopLabAndComboBox = this.renderTargPopLabAndComboBox();

        const enterParamsLab =
            <p
                key     = {"enterParamsLab"}
                style   = {{
                    ...Theme.labelStyle,
                    color        : Theme.RC_SecondaryColor,
                    display      : "inline-block",
                    marginBottom : 0,
                    marginLeft   : Theme.leftIndent,
                    marginTop    : 0,
                }}
            >
                {RS(SC.GB_stEnterFollowingParams)}
            </p>;

        const infoBtn =
            <IconButton
                onClick = {this.onParamsInfoClick}
                style   = {{
                    color      : Theme.RC_SecondaryColor,
                    cursor     : "pointer",
                    display    : "inline-block",
                    marginLeft : Theme.leftIndent,
                    padding    : 0,
                }}
            >
                <Info
                    style = {{
                        color : Theme.RC_SecondaryColor,
                    }}
                />
            </IconButton>;

        let startAgeComboBox = null;
        let endAgeComboBox = null;
        let refPeriodComboBox = null;
        let genderComboBox = null;
        let targPopParamDiv = null;
        let targPopParamsLab = null;

        if (!(customIndBool && (targPopType === rcc.customTargPop))) {

            let indCurrID = selectedIndCurrID;
            if (customIndBool) {

                indCurrID = rcu.getDefIndCurrIDFromTargPopCurrID(targPopCurrID);

            }

            const defIndAgeLowerBoundStart = rcu.getDefIndAgeLowerBoundStart(indCurrID);
            const defIndAgeLowerBoundEnd = rcu.getDefIndAgeLowerBoundEnd(indCurrID);
            const defIndAgeUpperBoundStart = rcu.getDefIndAgeUpperBoundStart(indCurrID);
            const defIndAgeUpperBoundEnd = rcu.getDefIndAgeUpperBoundEnd(indCurrID);
            const defIndRefPeriod = rcu.getDefIndRefPeriod(indCurrID);
            const defIndGender = rcu.getDefIndGender(indCurrID);

            if ((defIndAgeLowerBoundStart !== RS(SC.GB_stNA)) ||
                (defIndAgeLowerBoundEnd !== RS(SC.GB_stNA)) ||
                (defIndAgeUpperBoundStart !== RS(SC.GB_stNA)) ||
                (defIndAgeUpperBoundEnd !== RS(SC.GB_stNA)) ||
                (defIndRefPeriod !== RS(SC.GB_stNA)) ||
                (defIndGender !== RS(SC.GB_stNA))) {

                targPopParamsLab =
                    <p
                        style      = {{
                            marginLeft : Theme.leftIndent,
                            ...Theme.labelStyle,
                            marginTop    : 25,
                            marginBottom : 0,
                        }}
                    >
                        {RS(SC.GB_stSpecParamsTargPop)},&nbsp;

                        <span
                            style = {{
                                color : Theme.RC_PrimaryColor,
                            }}
                        >
                        {rcu.getDefTargPopName(targPopCurrID)}
                    </span>
                    </p>;

                startAgeComboBox = this.renderStartAgeComboBox();
                endAgeComboBox = this.renderEndAgeComboBox();
                refPeriodComboBox = this.renderRefPeriodComboBox();
                genderComboBox = this.renderGenderComboBox();

                targPopParamDiv =
                    <div
                        style      = {{
                            top : Theme.topIndent,
                        }}
                    >
                        {startAgeComboBox}
                        {endAgeComboBox}
                        {refPeriodComboBox}
                        {genderComboBox}
                    </div>;

            }

        }

        const targPopParamsTable = this.renderTargPopParamsTable();

        const navBtnDiv =
            <RCNavBtnDiv
                divStyle       = {{
                    marginTop : 20,
                }}
                onBackBtnClick = {() => onPageChange(rcc.selectIndicatorsForm)}
                //onNextBtnClick = {() => onPageChange(RCConst.defineGroupingsForm)}
                nextBtnEnabled = {rcdu.allIndCompleted(indicatorObjList)}
                onNextBtnClick = {this.onNextBtnClick}
            />;

        let paramsHelpDialog = null;

        if (showParamsHelpDialog) {

            const header =
                <p
                    key   = {"header_p"}
                    style = {{
                        ...Theme.labelStyle,
                        //color         : Theme.appColors.primary,
                        padding : 0,
                        margin  : 0,
                    }}
                >
                    {RS(SC.GB_stParameters)}
                </p>;

            const text =
                <p
                    key   = {"text_p"}
                    style = {{
                        ...Theme.labelFontStyle,
                        padding : 0,
                        margin  : 0,
                    }}
                >
                    {RS(SC.GB_stParamHelpText)}
                </p>;

            paramsHelpDialog =
                <TDialog
                    actions = {['mrClose']}
                    content = {[text]}
                    header  = {[header]}
                    key     = {"autoCalcModernCPRDialog"}
                    onClose = {this.onParamsDialogClose}
                />;

        }

        return (

            <React.Fragment>

                {selectIndInstructLab}
                {fillOutAllIndNote}
                {indDiv}
                {customIndTargPopTypeRadGrp}
                {targPopLabAndComboBox}
                {targPopParamsLab}
                {targPopParamDiv}
                <div
                    style = {{
                        alignContent : "flex-start",
                        display      : "flex",
                        marginTop    : 20,
                    }}
                >
                    {enterParamsLab}
                    {infoBtn}
                </div>
                {targPopParamsTable}
                {navBtnDiv}
                {paramsHelpDialog}

            </React.Fragment>

        );

    }

}

export default RCAssignTargPopsForm;
